import React from "react"
import BaseTextInput from "./BaseTextInput"
import RegularNumberFormatter from "./RegularNumberFormatter"
import {validateFloatingChars} from "./bloom-utils/validations"
import {deNumberStringToNumber} from "../../misc/utils"

export const widgetPercentPrototype = []

const percentProps = {
    onChangeValidations: [validateFloatingChars],
    endAdornment: "%",
    inputProps: {
        decimalScale: 2,
        fixedDecimalScale: true,
        inputMode: "decimal",
    },
    inputComponent: RegularNumberFormatter,
}

const PercentWithTwoDecimal = ({value, onValueChange, ...props}) => {
    const displayValue = Number.isNaN(Number(value)) ? 0 : value

    const onChange = (newValue) => {
        onValueChange(deNumberStringToNumber(newValue))
    }

    return (
        <BaseTextInput
            {...props}
            {...percentProps}
            value={displayValue}
            onValueChange={onChange}
        />
    )
}

export default PercentWithTwoDecimal